import { captureException, addBreadcrumb } from "@sentry/vue";
import type { ObservabilityHooks } from "@smeetz/utils-feature-flags";

// Routes the package's errors and breadcrumbs to Sentry, keeping it Sentry-agnostic.
export const ffObservability: ObservabilityHooks = {
  onError(error, context) {
    captureException(error, {
      tags: { module: "feature-flags" },
      extra: context,
    });
  },

  onBreadcrumb(message, data) {
    addBreadcrumb({
      category: "feature-flags",
      level: "info",
      message,
      data,
    });
  },
};
